import anime from 'animejs';
import { qsa } from '@/scripts/utils';

const sponsorLogo = (el) => {
  const images = qsa('[js-target="pictureimg"]', el);
  images.forEach(el => el.removeAttribute('js-target'));
  el.removeAttribute('js-rotation');

  const basicTimeline = anime.timeline();

  basicTimeline.add({
    targets: el,
    duration: 0,
    opacity: 1,
    offset: 0
  })
  .add({
    targets: images,
    duration: 750,
    opacity: [0, 1],
    translateY: [80, 0],
    translateZ: 0,
    easing: 'easeInOutSine',
    offset: 0,
  });

  return basicTimeline;
};

export default sponsorLogo;
